import type { Order } from '#domain/Order.ts';

import { anchorTourEndpointsAtEdges, canMoveStopInTour, type TourStop } from './TourStop.ts';

export const keepLockedStopsAndAnchorTourEndpoints = (
    currentStops: TourStop[],
    nextStops: TourStop[],
    orders: Order[] = []
) => {
    if (currentStops.length !== nextStops.length) {
        return nextStops;
    }

    const orderById = new Map(orders.map(order => [order.id, order]));
    const lockedStopIds = new Set(
        currentStops
            .filter(stop => !canMoveStopInTour(currentStops, stop, orderById.get(stop.orderId)))
            .map(stop => stop.id)
    );
    const movableStops = nextStops.filter(stop => !lockedStopIds.has(stop.id));

    const lockedStopsAtCurrentIndexes = currentStops.map((currentStop, index) => {
        if (lockedStopIds.has(currentStop.id)) {
            return currentStop;
        }

        return movableStops.shift() ?? nextStops[index];
    });

    return anchorTourEndpointsAtEdges(lockedStopsAtCurrentIndexes);
};
